import { useMutation } from "@tanstack/react-query";

import { HttpClientError, IQuerySettings, getQuerySettings } from '@dw/models/shared';
import { useHttpClient } from '@dw/hooks';
import { ICreateBlobUploadLinkRequest, IPreSignedBlobUrl } from "@dw/models/blob";

const BASE_URL = '/v1/blob';

export const useCreateBlobUploadLinkMutation = (settings?: IQuerySettings<IPreSignedBlobUrl, ICreateBlobUploadLinkRequest>) => {
    const { POST } = useHttpClient();

    const createBlobUploadLink = async (request: ICreateBlobUploadLinkRequest) => {
      return POST<IPreSignedBlobUrl>(`${BASE_URL}/upload-link`, request);
    }

    const querySettings = getQuerySettings(settings)
    return useMutation<IPreSignedBlobUrl, HttpClientError, ICreateBlobUploadLinkRequest>({
      ...querySettings,
      mutationFn: createBlobUploadLink,
    })
}